import React from "react"
import Layout from "../components/layout"
import { FilingsPiece } from "@multiagentbook/shared"
import { siteLinks, homeLink } from "../data/siteLinks"

/**
 * 404. GitHub Pages serves dist/404.html for any unknown path, and the SPA
 * catch-all route renders this too, so both entry points land here.
 *
 * The metadata used to be the service platform's - "manage your account",
 * "payments", og-service.png - copied across from buy.multiagentbook.com,
 * which meant every shared 404 link previewed as the wrong product.
 */
const siteMetadata = {
  title: "Designing Multi-Agent Systems",
  description: "That page does not exist. Designing Multi-Agent Systems: principles, patterns and implementation for AI agents.",
  author: "Victor Dibia",
  image: "/images/og-card.png",
  keywords: "multi-agent systems, ai agents, book",
  twitterUsername: "@designingwithml",
}

const NotFoundPage: React.FC = () => (
  <Layout meta={siteMetadata} title="Page not found" link="/404">
    <main className="container mx-auto px-4 py-10 md:py-16">
      <FilingsPiece links={[homeLink, ...siteLinks]} />
    </main>
  </Layout>
)

export default NotFoundPage
